function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_150340",
  d: "M10.9,16.561a6,6,0,1,0-6-6A6.036,6.036,0,0,0,10.9,16.561Zm0-1.195a4.8,4.8,0,1,1,4.8-4.8A4.78,4.78,0,0,1,10.9,15.366Zm-.128-3.648a.487.487,0,0,0,.539-.423.307.307,0,0,1,.006-.07c.017-.3.22-.493.6-.742.574-.371.94-.708.94-1.375,0-.963-.87-1.52-1.9-1.52a1.827,1.827,0,0,0-1.85,1,.9.9,0,0,0-.058.3.456.456,0,0,0,.487.458c.342,0,.418-.174.6-.371a.876.876,0,0,1,.771-.458.671.671,0,0,1,.76.65c0,.354-.244.545-.737.882a1.315,1.315,0,0,0-.713,1.108v.064C10.21,11.549,10.413,11.718,10.773,11.718ZM10.761,13.5a.64.64,0,1,0-.684-.638A.649.649,0,0,0,10.761,13.5Z",
  transform: "translate(-4.903 -4.566)",
  fill: "#021d3d",
  opacity: 0.34
});

function SvgExplanation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11.994,
    viewBox: "0 0 12 11.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplanation);
export default __webpack_public_path__ + "static/media/explanation.83b1b476.svg";
export { ForwardRef as ReactComponent };